import React, { useEffect } from 'react'
import PropertySettingTabs from './Tabs'
import { Provider, useDispatch, useSelector } from 'react-redux'
import store from './store/store'
import { setInitialState } from './store/slice'

const Header = ({ buildingId, address }) => {
  return (
    <div className="dome-d-flex dome-flex-column dome-gap18">
      <div className="dome-d-flex dome-justify-between">
        <div>
          <h2 className="dome-h2 dome-color-dark-grey">{address}</h2>
        </div>
        <div className="dome-d-flex dome-align-center dome-gap12">
          <a className="dome-link dome-color-med-grey dome-link-chevron-left" href={`/buildings/${buildingId}/edit`}>
            back to building
          </a>
        </div>
      </div>
      <div style={{ height: 1, background: '#898989', width: '100%' }}></div>
    </div>
  )
}

export default function PropertySettingProvider(props) {
  return (
    <Provider store={store}>
      <PropertySetting {...props} />
    </Provider>
  )
}

function PropertySetting(props) {
  const { building, questionnaire_settings, organization_questionnaire_settings, questionnaire_prices } = props
  const dispatch = useDispatch()
  const { initialized } = useSelector((state) => state.buildingQuestionnaireAdmin)

  useEffect(() => {
    dispatch(
      setInitialState({
        questionnairePrices: questionnaire_prices,
        enabled: building.has_questionnaires,
        questionnaireType: questionnaire_settings.questionnaire_type,
        overrideGenericForm: questionnaire_settings.override_generic_form,
        genericFormId: questionnaire_settings.generic_form_id,
        limitAcceptedFormTypes: questionnaire_settings.limit_questionnaire_form_types,
        questionnaireAcceptedFormTypes: questionnaire_settings.questionnaire_accepted_form_types,
        organizationQuestionnaireType: organization_questionnaire_settings.questionnaire_type,
        adminEmails: props.questionnaire_emails,
      })
    )
  }, [dispatch])

  if (!initialized) return null

  return (
    <div className="container building-edit-questionnaire-settings">
      <div className="dome-d-flex dome-flex-column dome-gap30">
        <Header address={building.address} buildingId={building.id} />
        <div className="dome-d-flex dome-flex-column dome-gap18">
          <span className="dome-h2 dome-color-dark-grey">questionnaires</span>
          <PropertySettingTabs {...props} />
        </div>
      </div>
    </div>
  )
}
